import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSQuickListItemServices {

    static getAll(quickListId, pharmacyId, params = {}) {
        return axios.get(`${URL.PMS_QUICK_LIST_ITEMS}/${quickListId}/${pharmacyId}`, {
            ...PMSQuickListItemServices.getAuthHeader(),
            params,
        });
    }

    static getById(id, quickListId, pharmacyId) {
        return axios.get(`${URL.PMS_QUICK_LIST_ITEMS}/${id}/${quickListId}/${pharmacyId}`, PMSQuickListItemServices.getAuthHeader());
    }

    static create(quickListId, pharmacyId, data) {
        return axios.post(`${URL.PMS_CREATE_QUICK_LIST_ITEM}/${quickListId}/${pharmacyId}`, data, PMSQuickListItemServices.getAuthHeader());
    }

    static update(id, quickListId, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_QUICK_LIST_ITEM}/${id}/${quickListId}/${pharmacyId}`, data, PMSQuickListItemServices.getAuthHeader());
    }

    static delete(id, quickListId, pharmacyId) {
        return axios.delete(`${URL.PMS_DELETE_QUICK_LIST_ITEM}/${id}/${quickListId}/${pharmacyId}`, PMSQuickListItemServices.getAuthHeader());
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
